<div class="inside-container mat-elevation-z2">

    <div class="tab-header" fxLayout="row">
        <div fxFlex="15" fxLayoutAlign="start center">
            <h3 i18n="@@894965666917873756" t="894965666917873756">Document</h3>
        </div>
        <div fxFlex="70">
            <p></p>
        </div>
        <div fxFlex="15" fxLayoutAlign="end center">
        </div>
    </div>

    <app-document-grid [supplierCode]="supplierCode"></app-document-grid>
</div>